import React from 'react';
import Sixthgrade_k6 from './sixthgrade_k6';
import Sixthgrade_k6_subjects from './sixthgrade_k6_subjects';
const Sixthgrade_k6scie = () => {
  return (
    <div>
      <Sixthgrade_k6 />
    <Sixthgrade_k6_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>Science section</h1>
      <h3>English section in the curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Sixthgrade_k6scie;